export default __webpack_public_path__ + "static/media/logo.530acda7.png";